// ✅ src/pages/HelpButtons.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/HelpButton.css';

const HelpButtons = () => {
  const navigate = useNavigate();

  const handleAskAI = () => {
    navigate('/ask-ai');
  };

  const handleAskTeacher = () => {
    navigate('/waiting-room');
  };

  return (
    <div className="help-buttons-container">
      <h2>How would you like to get help?</h2>
      <div className="button-group">
        <button className="help-button ai" onClick={handleAskAI}>Ask AI</button>
        <button className="help-button teacher" onClick={handleAskTeacher}>Ask Teacher</button>
      </div>
    </div>
  );
};

export default HelpButtons;